/**
 *
 * @param text
 * @returns {string}
 */
export function getUrl(text){
    let result =text.replace(/[^A-Za-z']/g, "-");
    result = result.toLowerCase();

    return result;
}